import { bookingTypeColor } from './const';

interface Props {
  bookingType: number | null;
  isColumnEnabledForWaiting: boolean;
  userHasDeposit: boolean | null;
}

export const getBookingColor = ({ bookingType, isColumnEnabledForWaiting, userHasDeposit }: Props) => {
  switch (bookingType) {
    case null:
      return (
        isColumnEnabledForWaiting
          ? 'rgba(200, 80, 190, 0.2)'
          : 'transparent'
      );
    case 0:
      return (
        userHasDeposit
          ? bookingTypeColor[0]
          : bookingTypeColor[5]
      );
    default:
      return (bookingTypeColor[bookingType]);
  }
};
